









import { Component, Vue } from 'vue-property-decorator'
import AlarmForm from './AlarmForm.vue'
import { Alarm, AddAlarm } from '../store/alarm'
import { namespace } from 'vuex-class'
const alarmStore = namespace('alarm')
@Component({ components: { AlarmForm } })
export default class AddAlarmModal extends Vue {
  dialog = false
  @alarmStore.Action add!: (sensor: AddAlarm) => Promise<Alarm>

  async addAlarm(alarm: AddAlarm) {
    await this.add(alarm)
    this.dialog = false
  }
}
